function getCookie(cname) {
                         var name = cname + "=";
                         var decodedCookie = decodeURIComponent(document.cookie);
                         var ca = decodedCookie.split(";");
                         for(var i = 0; i < ca.length; i++) {
                         var c = ca[i];
                       while (c.charAt(0) == " ") {
                       c = c.substring(1);
                     }
                     if (c.indexOf(name) == 0) {
                       return c.substring(name.length, c.length);
                     }
                   }
                  return "";
              }
    var all_zip_codes = ["411***"];
          //----- end all zip codes ----
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
          $(document).ready(function(){
            if(getCookie("code") != null)
            { 
              if(getCookie("code_status") == "true"){
             $("#check_status").html("We deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
                    $("#check_status").css("color","green");
                     $(".farm").css("display","none");
                  $(".check_again").css("display","block");
                  }
              if(getCookie("code_status") == "false"){
                 $("#check_status").html("We do not deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
                $("#check_status").css("color","red");
                 $(".farm").css("display","none");
                 $(".check_again").css("display","block");
                   }
           }
          else
            { 
              $(".farm").css("display","block");
            }

           //form show 
            $(".check_again").click(function(){
              $(".farm").css("display","block");
              $(".check_again").css("display","none");
              }); 

   //on enter key pressed
            $("#zip_value").keypress(function (e) {                                       
            if (e.which == 13) {
            e.preventDefault();
            var zip_code=$("#zip_value").val();
                
                if(zip_code==""){
                $("#check_status").text("Please write the correct zip code !");
                $("#check_status").css("color","black")
                                }
                else{
                  var arr_zip=[];
                  for(var i=0;i<all_zip_codes.length;i++)
                  {
                    if(all_zip_codes[i].indexOf("***")!=-1)
                    {
                      var rm_stripe=all_zip_codes[i].replace("***","");
                      arr_zip.push(rm_stripe)
                      }
    
       //code result display     
     if($.inArray(zip_code,all_zip_codes)!=-1)
     {
       
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","green");
       document.cookie = "code_status="+"true"+"; path=/";
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
         //form
       
           $(".check_again").click(function(){
           $(".farm").css("display","block");
           $(".check_again").css("display","none");

            }); 
     
       
    }
    else if($.inArray(zip_code.substring(0,3),arr_zip)!=-1)
    {
      
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","green");
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
       document.cookie = "code_status="+"true"+"; path=/";
      
      //form
      
            $(".check_again").click(function(){
            $(".farm").css("display","block");
            $(".check_again").css("display","none");

          });
    } 
    else
    {
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We do not deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","red");
       document.cookie = "code_status="+"false"+"; path=/";
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
      
      //form
      
           $(".check_again").click(function(){
           $(".farm").css("display","block");
           $(".check_again").css("display","none");

            });
     
    }  
                   
  }
             
}

}
});
            //on clicking-------
              $("#check_zip_code").click(function(){
             
                var zip_code=$("#zip_value").val();
                
                if(zip_code==""){
                $("#check_status").text("Please write the correct zip code !");
                $("#check_status").css("color","black")
                                }
                else{
                  var arr_zip=[];
                  for(var i=0;i<all_zip_codes.length;i++)
                  {
                    if(all_zip_codes[i].indexOf("***")!=-1)
                    {
                      var rm_stripe=all_zip_codes[i].replace("***","");
                      arr_zip.push(rm_stripe)
                      }
    
       //code result display     
     if($.inArray(zip_code,all_zip_codes)!=-1)
     {
       
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","green");
       document.cookie = "code_status="+"true"+"; path=/";
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
         //form
       
           $(".check_again").click(function(){
           $(".farm").css("display","block");
           $(".check_again").css("display","none");

            }); 
     
       
    }
    else if($.inArray(zip_code.substring(0,3),arr_zip)!=-1)
    {
      
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","green");
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
       document.cookie = "code_status="+"true"+"; path=/";
      
      //form
      
            $(".check_again").click(function(){
            $(".farm").css("display","block");
            $(".check_again").css("display","none");

          });
    } 
    else
    {
       document.cookie = "code="+zip_code+"; path=/";
       var cookie_value=getCookie("code")+"<br>";
       var tag="check_again";
       $("#check_status").html("We do not deliver in your area! "+cookie_value+"<span class="+tag+">Check Again ZipCode</span>");
       $("#check_status").css("color","red");
       document.cookie = "code_status="+"false"+"; path=/";
       $(".farm").css("display","none");
       $(".check_again").css("display","block !important");
      
      //form
      
           $(".check_again").click(function(){
           $(".farm").css("display","block");
           $(".check_again").css("display","none");

            });
     
    }  
                   
  }
             
}

});

});